const CapitalizeFirstLetter = (value: string): string => {
  return value.charAt(0).toUpperCase() + value.toLowerCase().slice(1);
};

export default CapitalizeFirstLetter;
